import { Box, Typography } from '@material-ui/core'
import ErrorOutline from '@material-ui/icons/ErrorOutline'

import Card from '../card'
import { useStyles } from './styles'

type MessageModalProps = {
  title: string
  message: string
  type?: string
}

export function MessageModal({ title, message, type }: MessageModalProps) {
  const classes = useStyles()

  return (
    <Box className={classes.main}>
      <Card className={classes.card}>
        {type === 'error' ? (
          <div className={classes.errorContainer}>
            <ErrorOutline className={classes.errorIcon} />
            <Typography variant='h4' className={classes.errorText}>
              {title}
            </Typography>
          </div>
        ) : (
          <Typography variant='h4' className={classes.title}>
            {title}
          </Typography>
        )}
        <Typography className={classes.message} variant={'body1'}>
          {message}
        </Typography>
      </Card>
    </Box>
  )
}
